module.exports = __webpack_public_path__ + "static/media/SPADE-6.fdf9d937.svg";